module.exports = __webpack_public_path__ + "img/12.29b539b6.svg";